(() => {
  'use strict';

  /*
   * Le script panier historique optimisait le panier lors de pageshow,
   * donc sans action explicite du client. Cette couche bloque uniquement
   * la première requête silencieuse /cart/update.js après restauration
   * d'une page. Une interaction utilisateur lève immédiatement le blocage.
   */
  const nativeFetch = window.fetch.bind(window);
  let protectRestoredCart = false;
  let timer = 0;

  const releaseProtection = () => {
    protectRestoredCart = false;
    window.clearTimeout(timer);
  };

  window.addEventListener('pageshow', () => {
    protectRestoredCart = true;
    window.clearTimeout(timer);
    timer = window.setTimeout(releaseProtection, 2500);
  }, true);

  ['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, releaseProtection, { capture: true, passive: true });
  });

  window.fetch = (input, init = {}) => {
    const requestUrl = typeof input === 'string' ? input : (input?.url || '');
    const requestMethod = String(
      init.method || (typeof Request !== 'undefined' && input instanceof Request ? input.method : 'GET')
    ).toUpperCase();

    if (
      protectRestoredCart
      && requestMethod === 'POST'
      && /\/cart\/update\.js(?:\?|$)/.test(requestUrl)
    ) {
      releaseProtection();
      return Promise.reject(new Error('Mise à jour automatique du panier bloquée.'));
    }

    return nativeFetch(input, init);
  };

  const prepareNewsletterForms = (root = document) => {
    root.querySelectorAll('.nl-cta__form input[name="contact[tags]"]').forEach((input) => {
      const tags = new Set(
        String(input.value || '')
          .split(',')
          .map((tag) => tag.trim())
          .filter(Boolean)
      );
      tags.add('newsletter');
      tags.add('newsletter-cadeau-lcdd');
      input.value = Array.from(tags).join(',');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareNewsletterForms(), { once: true });
  } else {
    prepareNewsletterForms();
  }

  document.addEventListener('shopify:section:load', (event) => {
    prepareNewsletterForms(event.target);
  });
})();
